import React, { useMemo } from 'react';
import useIntl from '@i18n/useIntl';
import Banner from '@components/notifications/banner/Banner';
import { BannerTypes } from '@components/notifications/enums';
import { BusinessVerificationStatus } from '@models/account';
import {
  ACCOUNT_SETTINGS_BANNER_ID,
  BUSINESS_VERIFICATION_REJECTED_BANNER_MESSAGE_KEY,
} from 'src/pages/accountSettings/constants';
import { AlertProps } from '@amzn/storm-ui';

interface AccountSettingsBannerProps {
  status?: BusinessVerificationStatus;
}

interface BannerConfigProps {
  props: Partial<AlertProps>;
  message: string;
}

const AccountSettingsBanner = ({ status }: AccountSettingsBannerProps) => {
  const { intl } = useIntl();

  if (
    !status ||
    status === BusinessVerificationStatus.Verified ||
    status === BusinessVerificationStatus.Pending
  ) {
    return null;
  }

  const bannerConfig = useMemo<BannerConfigProps>(() => {
    switch (status) {
      case BusinessVerificationStatus.Rejected:
        return {
          props: { type: BannerTypes.Error, withCloseButton: true },
          message: intl.getMessage(
            BUSINESS_VERIFICATION_REJECTED_BANNER_MESSAGE_KEY,
          ),
        };
    }
  }, [status, intl]);

  const { props, message } = bannerConfig;

  return (
    <Banner
      id={ACCOUNT_SETTINGS_BANNER_ID}
      props={props}
      message={message}
      duration={0}
    />
  );
};

export default AccountSettingsBanner;
